import { ApolloCache } from '@apollo/client';
import { CachedData } from '@modules/common/utils/isCachedData';

export const deleteAllCachedQueries = (
  cache: ApolloCache<CachedData>,
  deletionRegex: string,
  filterRegex?: string,
) => {
  const cacheData = cache.extract();
  // There is no direct way to delete all cached queries matching a certain
  // query method. This is a hack to go through all cached queries and evicting
  // them based on match condition.
  // Ref: https://stackoverflow.com/q/48596265
  Object.keys(cacheData?.ROOT_QUERY).forEach((key: string) => {
    if (!filterRegex || key.match(filterRegex)) {
      if (key.match(deletionRegex)) {
        cache.evict({ id: 'ROOT_QUERY', fieldName: key });
      }
    }
  });
  cache.gc();
};
